export default "__VITE_ASSET__CKeDTheY__"